import { dataFetcher } from 'core/services/requestHandler';   

const getReferralCode = async (data = {}, config = {}) => {
  return dataFetcher('getReferralCode', data, {...config});
};

const createReferral = async (data = {}, config = {}) => {
  return dataFetcher('createReferral', data, {...config});
};


export { getReferralCode, createReferral};
